/**
 * Dumb component to render a search box for a virtual repeater.
 * This will probably end up being greatly expanded... maybe even to an advanced search?
 */
export class ClVirtualRepeaterSearchComponent implements angular.IComponentOptions {
    public bindings: any = {
        divId: '@',
        isActive: '=', // need to convert this to 1 way + event
        isDisabled: '<',
        searchFn: '&'
    };

    public controller = ClVirtualRepeaterSearchController;

    // tslint:disable
    public template: string = `
        <md-card class="cl-vr-search" ng-if="$ctrl.isSearching" layout="row">
            <cl-input-container md-no-float>
                <cl-input cl-autofocus="true" name="tableSearch" ng-model="$ctrl.searchTerm" on-enter-key="$ctrl.search()" placeholder="Search table..." ignore-dirty></cl-input>
            </cl-input-container>
            <cl-button icon="portal:close" icon-button="true" click-action="$ctrl.clear()" btn-text="Clear & Close"></cl-button>
        </md-card>

        <cl-button click-action="$ctrl.search();$ctrl.toggleSearchBox();" material-icon="check_circle" icon-button="true" btn-text="Search" ng-if="$ctrl.isSearching"></cl-button>
        <cl-button material-icon="search" icon-button="true" icon-class="{{ $ctrl.isActive ? 'active-inset' : '' }}" click-action="$ctrl.toggleSearchBox()" btn-text="Search" ng-disabled="$ctrl.isDisabled" ng-if="!$ctrl.isSearching"></cl-button>
    `;
    // tslint:enable

    public transclude: boolean = true;
}

// tslint:disable-next-line: max-classes-per-file
export class ClVirtualRepeaterSearchController implements angular.IComponentController {
    /**
     * The virtual repeaters should be stored as IDataTable objects --
     * we need the divId to access them properly back in the parent scope
     */
    private divId: string;

    /**
     * Whether or not a search is currently performed --
     * we'll use this for enabling/disabling things on parents,
     * as well as highlighting the icon while active
     */
    private isActive: boolean;

    /** Whether or not the button is greyed out */
    private isDisabled: boolean;

    /** Display the box if this is true, or the icon if it is false */
    private isSearching: boolean = false;

    /** The predicate of the search */
    private searchTerm: string = '';

    /** The function to perform, passed in from an outside source */
    private searchFn: (options: { searchTerm: string }) => void;

    private clear() {
        this.searchTerm = '';
        this.search();
    }

    private search() {
        this.searchFn({ searchTerm: this.searchTerm });

        this.isActive = this.searchTerm ? true : false;
    }

    private toggleSearchBox() {
        this.isSearching = !this.isSearching;
    }
}
